/** Shared product analytics belongs only to the production SweetSpot web origins.
 * Storefront domains use their own instrumentation; previews and native apps stay out.
 */
export function isProductAnalyticsHost(protocol: string, hostname: string) {
  return protocol === 'https:' && ['sweetspot.la', 'www.sweetspot.la'].includes(hostname.toLowerCase());
}
